export const InvoicesSummary = ({ invoices, formatCurrency, showAdminFee = false, summary = null }) => {
    const confirmedInvoices = invoices.filter(i => i.confirmed === true);
    const pendingInvoices = invoices.filter(i => i.confirmed !== true);
    
    // Server summary (whole filter) wins over the loaded page, so admin and supervisors always see the same numbers
    const confirmedCount = summary ? summary.confirmed_count : confirmedInvoices.length;
    const pendingCount = summary ? summary.pending_count : pendingInvoices.length;
    const totalConfirmed = summary ? summary.confirmed_total : confirmedInvoices.reduce((sum, i) => sum + i.amount, 0);
    const totalPending = summary ? summary.pending_total : pendingInvoices.reduce((sum, i) => sum + i.amount, 0);
    const total = summary ? summary.total : invoices.reduce((sum, i) => sum + i.amount, 0);

    return (
        <div className="mt-4 pt-4 border-t border-slate-200 flex flex-wrap gap-4 text-sm" data-testid="invoices-summary">
            <div className="bg-green-50 px-4 py-2 rounded-lg">
                <span className="text-green-600 font-medium" data-testid="summary-confirmed-count">
                    Confirmadas: {confirmedCount}
                </span>
                <span className="text-green-700 font-bold ml-2" data-testid="summary-confirmed-total">
                    {formatCurrency(totalConfirmed)}
                </span>
            </div>
            <div className="bg-amber-50 px-4 py-2 rounded-lg">
                <span className="text-amber-600 font-medium">
                    Pendientes: {pendingCount}
                </span>
                <span className="text-amber-700 font-bold ml-2">
                    {formatCurrency(totalPending)}
                </span>
            </div>
            <div className="bg-sky-50 px-4 py-2 rounded-lg">
                <span className="text-sky-600 font-medium">
                    Total:
                </span>
                <span className="text-sky-700 font-bold ml-2">
                    {formatCurrency(total)}
                </span>
            </div>
            {/* 3% fee from confirmed - Only for admin */}
            {showAdminFee && (
                <div className="bg-purple-50 px-4 py-2 rounded-lg">
                    <span className="text-purple-600 font-medium">
                        3%:
                    </span>
                    <span className="text-purple-700 font-bold ml-2">
                        {formatCurrency(totalConfirmed * 0.03)}
                    </span>
                </div>
            )}
        </div>
    );
};

export default InvoicesSummary;
